module.exports = __webpack_public_path__ + "static/img/2_10@2x.2faf344.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_10@2x.png
// module id = myog
// module chunks = 8